export { default } from './RadarChart';
